import { action, extendObservable } from 'mobx';
import { UiService } from 'modules/ui';

import { EVENTS } from './constants';
import Store from './MembershipEventStore';

import Request from '@hotmart/request';

class MembershipEventService {
  @action
  setData(data = {}) {
    extendObservable(Store, {
      ...data,
      events: data?.events || []
    });
  }

  @action
  async init() {
    if (!Store.loaded) {
      await this.listUserEvents();
    }
  }

  @action
  async listUserEvents() {
    Store.loaded = false;
    let response = null;

    try {
      response = await Request('membershipEvent.listUserEvents');
      this.setData(response);
    } catch (error) {
      this.handleError(error);
    } finally {
      Store.loaded = true;
    }

    return response;
  }

  @action
  async dismissEvent(eventName) {
    if (!eventName) {
      return;
    }

    let response = null;

    try {
      response = await Request('membershipEvent.dismissEvent', { eventName });
      this.setData({ events: Store.events.filter((evt) => evt !== eventName) });
    } catch (error) {
      this.handleError(error);
    }

    return response;
  }

  get hasSparkleCampaignSettingsEvent() {
    return Store.hasCampaignEvent(EVENTS.SPARKLE_CAMPAIGN_SETTINGS);
  }

  handleError(error) {
    UiService.handleError(error);
  }
}

export default new MembershipEventService();
